import { gql } from '@apollo/client'

export const GET_ROOM_VIEW_SCHEDULED_SURGERIES = gql`
  query GetRoomViewScheduledSurgeries(
    $input: GetRoomViewScheduledSurgeriesInput
  ) {
    getRoomViewScheduledSurgeries(input: $input) {
      _id
      patient {
        _id
        idMR
        firstName
        lastName
        dateOfBirth
        phoneNumber
        email
        referringPhysician {
          _id
          firstName
          lastName
          mobile
          email
          speciality
        }
      }
      procedure {
        dateTime
        duration
        description
        procedureInfo {
          description
          value
        }
      }
      visit {
        visitNumber
        location {
          department
          room
          bed
        }
      }
      attendingProvider {
        _id
        idNPI
        firstName
        lastName
        emailAddresses
        credentials
      }
      patientStatusHistory {
        status
        info {
          createdAt
          createdBy
          period
          formattedPeriod
          room {
            id
            parentLocationId
            order
            isAssignableToDepartment
            isAssignedToProcedure
            isInventoryLocation
            name
            description
          }
        }
      }
      surgeryStaff {
        _id
        firstName
        lastName
        roleDescription
        credentials
      }
    }
  }
`

export const GET_ROOM_VIEW_ROOMS = gql`
  query GetRoomViewRooms($input: GetRoomViewRoomsInput) {
    getRoomViewRooms(input: $input) {
      id
      procedureId
      name
      description
    }
  }
`

export const GET_SURGERY_STAFF = gql`
  query GetSurgeryStaff {
    getSurgeryStaff {
      _id
      firstName
      lastName
      roleDescription
      credentials
    }
  }
`
